import { RootState } from 'types';
import { IActionEditorState } from '.';

export const selectActionEditor = (state: RootState): IActionEditorState => state.actionEditor;
